import styled from 'styled-components';

interface IPropsContainerSideBar {
  isOpen: boolean;
  title: string;
  isMobile: boolean;
  isBlackScreen?: boolean;
}

export const Container = styled.aside<IPropsContainerSideBar>`
  .ant-menu .premium-course-item {
    background: #fff1df;
    border: 1px solid #f0d2a9;
    border-radius: 8px;
    color: #945013;
    font-weight: 600;
  }
  .ant-menu .premium-course-item span { color: #945013 !important; font-weight: 600; }
  .ant-menu .premium-course-item:hover { background: #ffe5bd; }
  .ant-menu .premium-course-item .ant-menu-title-content::before {
    content: '★';
    margin-right: 8px;
    color: #a96a12;
  }

  display: ${(props) => (props.isMobile ? 'none' : 'flex')};
  position: fixed;
  z-index: 99;
  top: 65px;
  bottom: 0;
  left: 0;
  flex-direction: column;
  min-height: 0;
   
  background-color: ${(props) =>
    props.isBlackScreen ? props.theme['gray-700'] : props.theme.white};
  overflow: hidden;
  transition: width 200ms ease;
  width: 60px;

  > .ant-layout {
    flex: 1 1 0;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior-y: contain;
    scrollbar-width: thin;
    scrollbar-color: #c3cbd4 transparent;
    background: inherit;
  }

  > .ant-layout::-webkit-scrollbar { width: 5px; }
  > .ant-layout::-webkit-scrollbar-thumb {
    background: #c3cbd4;
    border-radius: 8px;
  }

  .ant-layout-sider {
    flex: 0 0 auto !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    background: inherit;
  }

  .ant-layout-sider-children { height: auto; padding-bottom: 8px; }


  &:hover {
    width: 250px;
  }

  .minLogo {
    display: none;
  }


  .block {
    background-color: rgba(21, 21, 21, 0.3);
    cursor: no-drop;
  }
  /* ajustes tipografia */
  .ant-menu-title-content {
    font-size: 0.8rem !important;
    font-family: 'Poppins', sans-serif;
  }

  /* itens normais */
  .ant-menu-item, 
  .ant-menu-submenu-title {
    padding-left: 1rem !important;
    border-radius: 8px;
    margin: 4px 8px;
    transition: all 0.2s ease;
    color: ${(props) => props.theme['text-body']} !important;
    font-weight: 400;
  }

  /* hover */
  .ant-menu-item:hover, 
  .ant-menu-submenu-title:hover {
    background-color: #f4f6f9 !important;
    color: #1f2937 !important;
  }

  /* item selecionado */
  .ant-menu-item-selected {
    background-color: #e5ebf7 !important;
    font-weight: 600 !important;
    color: #1f2937 !important;
  }

  .ant-menu-item-selected svg {
    color: #1f2937 !important;
  }

  footer {
    display: flex;
    flex: 0 0 auto;
    min-height: 56px;
    border-top: 1px solid #e5e9ef;
    background-color: ${(props) =>
      props.isBlackScreen ? props.theme['gray-700'] : props.theme.white};

    width: 100%;
    padding: 16px 20px;
    align-items: center;

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      color: ${(props) =>
        props.isBlackScreen ? 'white' : props.theme['text-body']};
      font: 400 1rem 'Poppins', sans-serif;
      cursor: pointer;
      transition: color 0.3s;
    }
    .logoutIcon {
      transition: color 0.3s;
      color: ${(props) =>
        props.isBlackScreen ? 'white' : props.theme['text-body']};
    }

    :hover {
      span {
        color: red;
      }
      .logoutIcon {
        color: red;
      }
    }
  }
`;

export const ContainerShort = styled.aside`
  position: fixed;
  z-index: 100;
  width: 50px;
  height: 100%;
  background-color: ${(props) => props.theme.white};
  overflow-y: auto;
  transition: width 1s;
`;

export const HeaderSideBar = styled.header`
  display: flex;

  padding: 1.187rem 4rem 0 0.75rem;
  object-fit: fill;
  width: 100%;
  img {
    width: 8.125rem;
    cursor: pointer;
  }

  @media (max-width: 820px) {
    padding: 1rem 0 0 0.25rem;
  }
`;

export const ShowSideBar = styled.div<IPropsContainerSideBar>`
  clip-path: polygon(100% 77%, 100% 23%, 70% 0, 70% 100%);
  cursor: pointer;
  width: 100%;
  height: 100%;
  max-width: 3rem;
  max-height: 5rem;
  position: fixed;
  background: ${(props) => props.theme.white};
  transition: all 1s;
  left: ${(props) => (props.isOpen ? '13.5rem' : '1.5rem')};
  top: 17rem;
  display: ${(props) => (props.isMobile ? 'none' : 'block')};
  z-index: 100;
  h2 {
    margin: 0;
    padding: 0;
    font-size: 1rem;
    color: ${(props) => props.theme.black};
    display: flex;
    justify-content: end;
    align-items: center;
    height: 100%;
    padding-right: 5px;
  }
`;
